import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  getDispatchManagers,
  getDispatchManager,
  updateDispatchManager,
  insertDispatchManager,
} from "../services/managerService";
import type {
  UpdateManagerRequest,
  InsertManagerRequest,
} from "../types/manager.types";

export const useManagerList = (companyGuid: string | null) =>
  useQuery({
    queryKey: ["dispatchManagers", companyGuid],
    queryFn: () => getDispatchManagers(companyGuid!),
    enabled: !!companyGuid,
  });

export const useManagerDetail = (accountGuid: string | null) =>
  useQuery({
    queryKey: ["dispatchManager", accountGuid],
    queryFn: () => getDispatchManager(accountGuid!),
    enabled: !!accountGuid,
    gcTime: 0,
  });

export const useUpdateManager = (companyGuid: string | null) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (req: UpdateManagerRequest) => updateDispatchManager(req),
    onSuccess: () => {
      toast.success("담당자 정보가 수정되었습니다.");
      qc.invalidateQueries({ queryKey: ["dispatchManagers", companyGuid] });
    },
    onError: (err: Error) => {
      toast.error(`수정 실패: ${err.message}`);
    },
  });
};

export const useInsertManager = (companyGuid: string | null) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (req: InsertManagerRequest) => insertDispatchManager(req),
    onSuccess: () => {
      toast.success("담당자가 등록되었습니다.");
      qc.invalidateQueries({ queryKey: ["dispatchManagers", companyGuid] });
    },
    onError: (err: Error) => {
      toast.error(`등록 실패: ${err.message}`);
    },
  });
};
